import Const from '../const';
import createReducer from '../config/create_reducer';

const clearedOrderKey = ({ orderKey, state }) => {
  const clearedOrderKeys = Object.keys(state.pendingWebOrder)
    .filter((key) => key !== orderKey);
  const clearedOrder = {};
  clearedOrderKeys.forEach((key) => {
    clearedOrder[key] = state.pendingWebOrder[key];
  });
  return clearedOrder;
};

const getDefaultState = () => ({
  pendingWebOrder: {
    nickname: '',
    dateOfBirth: null,
    gender: ''
  }
});

const handler = {
  [Const.order.save]: (state, { props }) => ({
    pendingWebOrder: {
      ...state.pendingWebOrder,
      ...props
    }
  }),
  [Const.order.clearOrderKey]: (state, { orderKey }) => ({
    pendingWebOrder: { ...clearedOrderKey({ orderKey, state }) }
  })
};

export default createReducer(getDefaultState(), handler);
